<footer class="footer">
    <div class="container-xxl px-4">
        <div class="row justify-content-lg-center">
            <div class="col-12 col-lg-auto">
                <app-footer-menu [isDesktop]="isDesktop"></app-footer-menu>
                @if (!isDesktop) {
                    <div class="border-btn my-3"></div>
                }
            </div>
            <div class="col-12 col-lg-auto mx-lg-12">
                <app-additional-info [isDesktop]="isDesktop"></app-additional-info>
                @if (!isDesktop) {
                    <div class="border-btn my-3"></div>
                }
            </div>
            <div class="col-12 col-lg-auto">
                <app-contact [isDesktop]="isDesktop"></app-contact>
                @if (!isDesktop) {
                    <div class="border-btn my-3"></div>
                }
            </div>
            <div class="col-12 col-lg-auto ms-lg-12">
                <app-social [isDesktop]="isDesktop" />
                @if (!isDesktop) {
                    <div class="border-btn my-3"></div>
                }
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-copy></app-copy>
            </div>
        </div>
    </div>
</footer>
